import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map as rxMap } from 'rxjs/operators';
import { INavItem } from 'Src/ng2/network/network-left-side-nav/network-left-side-nav.component';
import { Auth } from 'Src/ng2/shared/auth/auth.service';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { IPartner, TValidPartnerTypes } from 'Src/ng2/shared/typings/interfaces/partner.interface';
import { IUser } from 'Src/ng2/shared/typings/interfaces/user.interface';
import { getCurrentUser } from 'Src/ng2/store/selectors/current-user-selectors';
import { ISidebarItem } from 'Src/nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';
import { IWindowService } from 'angular';

@Component({
  selector: 'shelter-side-nav',
  template: require('./shelter-side-nav.component.html'),
  styles: [require('./shelter-side-nav.component.scss')],
})
export class ShelterSideNavComponent {
  partnerType: TValidPartnerTypes = 'shelter';
  partner: IPartner;
  isClusterUser$: Observable<boolean>;
  sidebarOptions: ISidebarItem[] = [
    {
      human: 'Attendance',
      key: 'Attendance',
    },
    {
      human: 'Data grid',
      key: 'Data grid',
    },
  ];
  selectedKey: string = 'Attendance';
  shelter: string;
  userMenuOptions = [
    {
      key: 'reportIssues',
      humanName: 'Report Issues',
      stateName: null,
    },
    {
      key: 'privacyAndTerms',
      humanName: 'Privacy & Terms',
      stateName: 'privacy-and-terms',
    },
    {
      key: 'logOut',
      humanName: 'Log out',
      stateName: null,
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: Auth,
    private imUser: ImUser,
    private store: Store<any>,
    @Inject('$window') private $window: IWindowService,
  ) {}

  ngOnInit(): void {
    this.partner = this.route.snapshot.data.shelter;
    this.isClusterUser$ = this.store
      .select(getCurrentUser)
      .pipe(rxMap((currentUser: IUser) => this.imUser.isClusterUser(currentUser, 'shelter')));
  }

  switchPartner(): void {
    const url = 'shelter-picker';
    this.router.navigate([url]);
  }

  goToList(): void {
    // current route url is 'shelter/:shelterId/lists'
    this.router.navigate(['attendance-list'], { relativeTo: this.route });
  }

  goToGrid(): void {
    // current route url is 'shelter/:shelterId/lists'
    this.router.navigate(['../grid'], { relativeTo: this.route });
  }

  goExternal(selection): void {
    selection === 'Data grid' ? this.goToGrid() : this.goToList();
  }

  logout(): void {
    this.auth.logout();
  }

  public goToState(option: INavItem): void {
    switch (option.key) {
      case 'reportIssues':
        this.$window.FreshWidget.show();
        break;
      case 'privacyAndTerms':
        this.$window.open('https://portal.newvisions.org/privacy-and-terms', '_blank');
        break;
      case 'logOut':
        this.logout();
        break;
      default:
        return null;
    }
  }
}
